import React from "react";
import DashboardHeader from "../components/Shop/Layout/DashboardHeader";
import DashboardSideBar from "../components/Shop/Layout/DashboardSideBar";
import SponsoredPostsAdmin from "../components/Admin/SponsoredPostsAdmin";

const AdminDashboardAds = () => {
  return (
    <div className="shop-create-advertisement-campaign-container">
      <DashboardHeader />
      <div className="ad-dashboard-layout shop-management-layout">
        <div className="shop-management-sidebar-slot">
          <DashboardSideBar active={8} />
        </div>
          <main className="shop-management-main-panel admin-dashboard-ads-main admin-page-shell">
            <header className="admin-page-hero">
              <div>
                <p className="admin-page-eyebrow">Super Admin Ads</p>
                <h1>AD Center</h1>
                <p className="admin-page-copy">Create sponsored placements, review campaign performance, and manage ad status safely.</p>
              </div>
            </header>
            <SponsoredPostsAdmin />
          </main>
      </div>
    </div>
  );
};

export default AdminDashboardAds;
